module.exports = __webpack_public_path__ + "static/td-logo-white-73b61fdc96d9692e5cd608e7b9798747.png";